(() => {
  const replaceTextNodes = (root, replacements) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      const original = node.nodeValue;
      const updated = replacements.reduce(
        (value, [from, to]) => value.split(from).join(to),
        original
      );
      if (updated !== original) node.nodeValue = updated;
    }
  };

  const applyCommerceFacts = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    const main = document.querySelector('#MainContent, main');
    if (!main) return;

    if (path === '/policies/terms-of-sale') {
      replaceTextNodes(main, [
        ['7,99 €', '4,90 €'],
        ['65 €', '45 €'],
        [
          'la livraison standard coûte 4,90 € et prend généralement 3 à 5 jours ouvrés après expédition ; elle est offerte dès 45 € d’achat.',
          'la livraison en point relais est offerte sans minimum jusqu’au dimanche 18 octobre 2026 inclus. Aucun code n’est nécessaire. Les frais de livraison à domicile sont distincts et confirmés au paiement. Le transport standard prend généralement 3 à 5 jours ouvrés après expédition.',
        ],
      ]);
    }

    if (path === '/policies/privacy-policy') {
      replaceTextNodes(main, [
        ['ayna3dprint@gmail.com', 'contact@aynacreation.fr'],
        [
          '21 Rue Serge Rouzière, 14123 Fleury-sur-Orne, France',
          '173 rue de Courcelles, 75017 Paris, France',
        ],
        [
          'Aux fins de la législation applicable en matière de protection des données, nous sommes le responsable du traitement de vos informations personnelles.',
          'Aux fins de la législation applicable en matière de protection des données, l’entrepreneur individuel exploitant la marque Ayna sous le nom commercial AL2A est le responsable du traitement de vos informations personnelles.',
        ],
      ]);
    }
  };

  const setupReveals = () => {
    const items = document.querySelectorAll(
      '.ayna-statement, .ayna-editorial, .ayna-process, .ayna-final, .ayna-about__intro, .ayna-about__values, .ayna-about__feature, .ayna-faq__groups > section'
    );
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('ayna-is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ayna-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    items.forEach((item) => {
      if (item.classList.contains('ayna-reveal-ready')) return;
      item.classList.add('ayna-reveal-ready');
      observer.observe(item);
    });
  };

  const initialise = () => {
    applyCommerceFacts();
    setupReveals();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
})();

(() => {
  const elephantImage = 'https://cdn.shopify.com/s/files/1/0988/3330/1837/files/elephantensemble_ad63b205-5240-462d-b788-dda25fcd51bf_800x800.png?v=1787586357';

  const replaceFooterCopy = () => {
    const footer = document.querySelector('footer');
    if (!footer) return;

    const replacements = [
      ['Entrez dans l’univers Ayna', 'Inscrivez-vous à la newsletter'],
      ['Entrez dans l’univers Aïna', 'Inscrivez-vous à la newsletter'],
      [
        'Recevez nos nouveautés, inspirations et idées cadeaux. Pas de spam, seulement de jolies nouvelles.',
        'Renseignez votre adresse e-mail et bénéficiez de 5 % de remise sur votre prochaine commande. Vous recevrez également nos nouveautés et idées cadeaux.'
      ]
    ];

    const walker = document.createTreeWalker(footer, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const original = node.nodeValue;
      const updated = replacements.reduce(
        (value, [from, to]) => value.split(from).join(to),
        original
      );
      if (updated !== original) node.nodeValue = updated;
    }
  };

  const addElephantProductSpacing = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    document.body.classList.toggle(
      'ayna-elephant-product-page',
      path === '/products/petit-elephant-decoratif'
    );
  };

  const addHomeElephantSection = () => {
    if (window.location.pathname.replace(/\/$/, '') !== '') return;
    if (document.getElementById('ayna-home-elephant')) return;

    const title = [...document.querySelectorAll('h2, h3')].find((heading) =>
      heading.textContent.trim().toLowerCase().includes('un objet pensé autour de son prénom')
    );
    const anchor = title?.closest('section');
    if (!anchor) return;

    const section = document.createElement('section');
    section.id = 'ayna-home-elephant';
    section.className = 'ayna-home-elephant';
    section.setAttribute('aria-labelledby', 'ayna-home-elephant-title');
    section.innerHTML =
      '<figure class="ayna-home-elephant__media">' +
        '<img src="' + elephantImage + '" alt="Collection de petits éléphants décoratifs Ayna en plusieurs couleurs" width="800" height="800" loading="lazy">' +
      '</figure>' +
      '<div class="ayna-home-elephant__content">' +
        '<p class="ayna-home-elephant__eyebrow">L’objet déco</p>' +
        '<h2 id="ayna-home-elephant-title">Un petit compagnon pour compléter son univers.</h2>' +
        '<p>À poser près de sa lettre, sur une étagère ou une commode, l’éléphant décoratif apporte une présence douce à la chambre. Il est disponible en blanc, bleu, rose, beige ou parme.</p>' +
        '<a href="/products/petit-elephant-decoratif">Découvrir les petits éléphants</a>' +
      '</div>';

    anchor.insertAdjacentElement('afterend', section);
  };

  const initialiseAynaAdditions = () => {
    replaceFooterCopy();
    addElephantProductSpacing();
    addHomeElephantSection();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAynaAdditions, { once: true });
  } else {
    initialiseAynaAdditions();
  }

  document.addEventListener('shopify:section:load', initialiseAynaAdditions);
})();


// Ayna — classes produit et logo de pied de page 2026-08-24
(() => {
  const addProductPageClasses = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    document.body.classList.toggle(
      'ayna-letter-product-page',
      path === '/products/lettre-decorative-personnalise'
    );
  };

  const addFooterLogo = () => {
    const footer = document.querySelector('footer');
    if (!footer || footer.querySelector('.ayna-footer-logo')) return;

    const source = document.querySelector(
      'header a[href="/"] img, header a[href*="aynacreation.fr"] img, header img'
    );
    if (!source) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'ayna-footer-logo';

    const link = document.createElement('a');
    link.href = '/';
    link.setAttribute('aria-label', 'Ayna — Accueil');

    const logo = source.cloneNode(true);
    logo.alt = 'Ayna';
    logo.removeAttribute('loading');
    logo.removeAttribute('fetchpriority');

    link.appendChild(logo);
    wrapper.appendChild(link);
    footer.appendChild(wrapper);
  };

  const initialiseAynaPagePolish = () => {
    addProductPageClasses();
    addFooterLogo();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAynaPagePolish, { once: true });
  } else {
    initialiseAynaPagePolish();
  }

  document.addEventListener('shopify:section:load', initialiseAynaPagePolish);
})();


// Ayna — boutons de rotation fiables pour la galerie
(() => {
  const arrowIcon = (direction) =>
    direction === 'previous'
      ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4.5 7 10l5.5 5.5"/></svg>'
      : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4.5 5.5 5.5-5.5 5.5"/></svg>';

  const addReliableGalleryArrows = () => {
    if (window.location.pathname.replace(/\/$/, '') !== '/products/lettre-decorative-personnalise') return;

    const nativePrevious = document.querySelector('button[aria-label="Diapositive précédente"]');
    const nativeNext = document.querySelector('button[aria-label="Diapositive suivante"]');
    const gallery = nativePrevious?.closest('slideshow-container');
    if (!gallery || !nativePrevious || !nativeNext || gallery.querySelector('.ayna-gallery-arrows')) return;

    gallery.classList.add('ayna-gallery-with-custom-arrows');

    const controls = document.createElement('div');
    controls.className = 'ayna-gallery-arrows';
    controls.setAttribute('aria-label', 'Navigation des photos');

    const previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'ayna-gallery-arrow';
    previous.setAttribute('aria-label', 'Photo précédente');
    previous.innerHTML = arrowIcon('previous');

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'ayna-gallery-arrow';
    next.setAttribute('aria-label', 'Photo suivante');
    next.innerHTML = arrowIcon('next');

    previous.addEventListener('click', () => nativePrevious.click());
    next.addEventListener('click', () => nativeNext.click());

    controls.append(previous, next);
    gallery.appendChild(controls);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addReliableGalleryArrows, { once: true });
  } else {
    addReliableGalleryArrows();
  }

  document.addEventListener('shopify:section:load', addReliableGalleryArrows);
})();


// Ayna — retrait du logo ajouté au pied de page
(() => {
  const removeFooterLogo = () => {
    document.querySelectorAll('.ayna-footer-logo').forEach((logo) => logo.remove());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeFooterLogo, { once: true });
  } else {
    removeFooterLogo();
  }

  document.addEventListener('shopify:section:load', removeFooterLogo);
})();



/* Ayna — ordre du parcours et galerie mobile */
(() => {
  const pagePath = window.location.pathname;

  const updateGuide = () => {
    if (pagePath !== '/pages/comment-ca-marche') return;

    const hero = document.querySelector('.ayna-guide__hero');
    if (hero) {
      hero.querySelectorAll('p').forEach((paragraph) => {
        paragraph.innerHTML = paragraph.innerHTML
          .replace('Prénom, couleurs, finitions et format', 'Prénom, couleurs, format et finitions');
      });
    }

    const steps = document.querySelector('.ayna-guide__steps');
    if (steps && !steps.dataset.aynaOrdered) {
      const items = [...steps.children];
      const finishes = items.find((item) => /Ajoutez vos finitions/.test(item.textContent));
      const format = items.find((item) => /Choisissez le format/.test(item.textContent));
      if (finishes && format) {
        steps.insertBefore(format, finishes);
        const formatNo = format.querySelector('span');
        const finishesNo = finishes.querySelector('span');
        if (formatNo) formatNo.textContent = '03';
        if (finishesNo) finishesNo.textContent = '04';
      }
      steps.dataset.aynaOrdered = 'true';
    }

    const finalCopy = document.querySelector('.ayna-guide__final');
    if (finalCopy) {
      finalCopy.querySelectorAll('p').forEach((paragraph) => {
        paragraph.innerHTML = paragraph.innerHTML
          .replace('les finitions, le format', 'le format, les finitions');
      });
    }

    const formats = document.querySelector('.ayna-guide #formats');
    const heading = formats?.querySelector('.ayna-guide__heading');
    const sizePhoto = formats?.querySelector('.ayna-guide__size-photo');
    if (formats && heading && sizePhoto && heading.nextElementSibling !== sizePhoto) {
      heading.insertAdjacentElement('afterend', sizePhoto);
    }
  };

  const revealSelectedLetter = (event) => {
    if (pagePath !== '/products/lettre-decorative-personnalise') return;
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.name !== 'ayna-letter-color-display') return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    window.setTimeout(() => {
      document.querySelector('slideshow-container')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 180);
  };

  document.addEventListener('DOMContentLoaded', updateGuide);
  document.addEventListener('shopify:section:load', updateGuide);
  updateGuide();
})();


/* Ayna — en-tête toujours visible et hauteur d’accueil synchronisée */
(() => {
  const header = document.querySelector('#header-component');
  const announcement = document.querySelector(
    '#shopify-section-sections--29412942610765__header_announcements_9jGBFp'
  );
  const headerSection = document.querySelector(
    '#shopify-section-sections--29412942610765__header_section'
  );

  const keepHeaderVisible = () => {
    if (!header) return;
    if (header.getAttribute('sticky') !== 'always') {
      header.setAttribute('sticky', 'always');
    }
    if (header.dataset.scrollDirection !== 'none') {
      header.dataset.scrollDirection = 'none';
    }
  };

  const syncHeaderHeight = () => {
    const total = Math.round(
      (announcement?.getBoundingClientRect().height || 0) +
      (headerSection?.getBoundingClientRect().height || 0)
    );
    if (total > 0) {
      document.documentElement.style.setProperty('--ayna-header-stack-height', total + 'px');
      document.documentElement.style.setProperty('--ayna-header-stack-height-mobile', total + 'px');
    }
  };

  keepHeaderVisible();
  syncHeaderHeight();

  if (header) {
    new MutationObserver(keepHeaderVisible).observe(header, {
      attributes: true,
      attributeFilter: ['sticky', 'data-scroll-direction']
    });
  }

  window.addEventListener('resize', syncHeaderHeight, { passive: true });
  document.addEventListener('shopify:section:load', () => {
    keepHeaderVisible();
    syncHeaderHeight();
  });
})();


/* Ayna — place la galerie juste avant Personnalisation sur mobile */
(() => {
  const isLetterPage = () =>
    window.location.pathname === '/products/lettre-decorative-personnalise';

  const arrangeLetterGallery = () => {
    if (!isLetterPage()) return;

    const grid = document.querySelector('.product-information__grid');
    const media = grid?.querySelector(':scope > .product-information__media') ||
      document.querySelector('.product-information__media.ayna-mobile-product-media');
    const details = grid?.querySelector(':scope > .product-details');
    const personalization = details?.querySelector('.ayna-personalization');
    const personalizationWrapper = personalization?.parentElement;
    const content = personalizationWrapper?.parentElement;

    if (!grid || !media || !details || !personalizationWrapper || !content) return;

    if (window.matchMedia('(max-width: 749px)').matches) {
      if (media.nextElementSibling !== personalizationWrapper) {
        content.insertBefore(media, personalizationWrapper);
      }
      media.classList.add('ayna-mobile-product-media');
    } else {
      if (media.parentElement !== grid || media.nextElementSibling !== details) {
        grid.insertBefore(media, details);
      }
      media.classList.remove('ayna-mobile-product-media');
    }
  };

  let resizeTimer;
  const scheduleArrangement = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(arrangeLetterGallery, 80);
  };

  document.addEventListener('DOMContentLoaded', arrangeLetterGallery);
  document.addEventListener('shopify:section:load', arrangeLetterGallery);
  window.addEventListener('resize', scheduleArrangement, { passive: true });
  arrangeLetterGallery();
})();


(() => {
  const initialiseHomeMotion = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    const main = document.querySelector('main[data-template="index"]');
    if (path !== '' || !main) return;

    const sections = main.querySelectorAll(
      '.ayna-statement, .ayna-editorial, .ayna-process, .ayna-home-elephant, .ayna-origin, .ayna-reviews, .ayna-final'
    );
    if (!sections.length) return;

    const items = [];
    sections.forEach((section) => {
      const candidates = Array.from(
        section.querySelectorAll(
          'img, figure, h2, .ayna-editorial__content, .ayna-process__intro, .ayna-process__steps, .ayna-home-elephant__media, .ayna-home-elephant__content, blockquote'
        )
      ).filter((candidate) => !candidate.parentElement.closest('.ayna-motion-item'));

      const unique = candidates.filter((candidate, index, all) => {
        return !all.some((other, otherIndex) =>
          otherIndex !== index && other.contains(candidate)
        );
      });

      unique.slice(0, 6).forEach((item, index) => {
        if (item.classList.contains('ayna-motion-item')) return;
        item.classList.add('ayna-motion-item');
        if (item.matches('img, figure, .ayna-home-elephant__media')) {
          item.classList.add('ayna-motion-item--media');
        }
        item.style.setProperty('--ayna-motion-delay', Math.min(index * 75, 300) + 'ms');
        items.push(item);
      });
    });

    if (!items.length) return;
    document.documentElement.classList.add('ayna-home-motion-ready');

    const show = (item) => item.classList.add('ayna-motion-visible');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(show);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -9% 0px',
      threshold: 0.12
    });

    items.forEach((item) => observer.observe(item));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseHomeMotion, { once: true });
  } else {
    initialiseHomeMotion();
  }

  document.addEventListener('shopify:section:load', initialiseHomeMotion);
})();


/* Ayna — désactivation du pop-up et message newsletter à -5 % */
(() => {
  const updateFooter = () => {
    document.querySelectorAll('footer p').forEach((paragraph) => {
      const text = paragraph.textContent.trim();
      if (text === 'Entrez dans l’univers Ayna') {
        paragraph.textContent = 'Inscrivez-vous à la newsletter';
      }
      if (text.includes('5 % de remise') || text.includes('5% de remise') || text.includes('10 % sur') || text.includes('10% sur')) {
        paragraph.textContent = 'Bénéficiez de −5 % sur votre première création en vous inscrivant à la newsletter.';
      }
    });
  };
  const removePopup = () => document.querySelectorAll('#ayna-newsletter-popup').forEach((popup) => popup.remove());
  const style = document.createElement('style');
  style.textContent = '#ayna-newsletter-popup{display:none!important}';
  document.head.appendChild(style);
  updateFooter();
  removePopup();
  document.addEventListener('DOMContentLoaded', updateFooter, { once: true });
  document.addEventListener('shopify:section:load', updateFooter);
})();

